import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/auth.context";

export default function MemberRoute() {
  const { loading, portalMode } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#4dbd07]"></div>
      </div>
    );
  }

  if (portalMode === "admin") {
    return <Navigate to="/access-denied" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
